export default function Logo({ className = "" }) {
    return (
        <div className={`flex items-center gap-3 select-none ${className}`}>
            {/* M box */}
            <div className="border border-gold/80 w-9 h-9 flex items-center justify-center shrink-0">
                <span className="font-serif text-gold text-xl font-bold leading-none">M</span>
            </div>

            {/* Divider */}
            <div className="w-px h-8 bg-gold/30" />

            {/* Text block */}
            <div className="flex flex-col justify-center leading-none gap-1">
                <div className="flex items-center gap-2">
                    <span className="font-serif text-white text-lg font-bold tracking-[0.15em] uppercase">Midasis</span>
                    <span className="font-serif text-gold text-lg font-bold tracking-[0.15em] uppercase">Flyaway</span>
                </div>
                <span className="font-sans text-white/40 text-[8px] tracking-[0.35em] uppercase">Travel Redefined</span>
            </div>
        </div>
    );
}
